import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }

import Home from "./Home.vue";
// IMP START - Setup Web3Auth Provider
import { Web3AuthProvider } from "@web3auth/modal-vue-composables"
import web3AuthContextConfig from "./web3authContext";
// IMP END - Setup Web3Auth Provider

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Web3AuthProvider), { config: _unref(web3AuthContextConfig) }, {
      default: _withCtx(() => [
        _createVNode(Home)
      ]),
      _: 1
    }, 8, ["config"])
  ]))
}
}

})